import { CompositeScreenProps } from '@react-navigation/native'
import React from 'react'
import { ScrollView } from 'react-native'

import { Page } from 'partials/Page'

import { Box } from 'widgets/Box'
import { FilledButton } from 'widgets/Button/FilledButton'
import { Separator } from 'widgets/Separator'

import { useCurrentUser } from 'hooks/useCurrentUser'

import { links } from 'utils/constants'

export const UpspaceSettingsPage = ({ navigation }: CompositeScreenProps<any, any>) => {
  const { data: currentUser, isLoading: isUserLoading } = useCurrentUser()

  return (
    <Page withBack withNav backgroundColor='white' title='Group Settings' navigation={navigation}>
      <Separator />
      <ScrollView>
        <Box margin={{ vertical: 'xl', horizontal: 'md' }}>
          <FilledButton
            loading={isUserLoading}
            disabled={isUserLoading}
            title='My Members'
            onPress={() =>
              navigation.navigate(links.GROUP_STACK, {
                screen: links.FOLLOWERS_MEMBERS_PAGE,
                params: {
                  trainer: currentUser,
                },
              })
            }
          />
          {/* <Box margin={{ top: 'md' }}>
            <BorderButton
              loading={isUserLoading}
              disabled={isUserLoading}
              title='Change Price'
              onPress={() =>
                Linking.openURL(
                  `https://share.hsforms.com/1Krjcuc5jSFiSeSGMEcn01Acaljb?email=${currentUser?.email}`,
                )
              }
            />
          </Box>
          <Box margin={{ top: 'md' }}>
            <BorderButton
              loading={isUserLoading}
              disabled={isUserLoading}
              title='Create Discount Code'
              onPress={() =>
                Linking.openURL(
                  `https://share.hsforms.com/1-FkfVWD_TPWEZhnqzGVZzwcaljb?email=${currentUser?.email}`,
                )
              }
            />
          </Box> */}
        </Box>
      </ScrollView>
    </Page>
  )
}
